import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEScienceTargetType as OEScienceTargetType_, OEScienceStartSelectionContent} from './oe-science-consts';

export const OEScienceTargetType = OEScienceTargetType_;

export const OEScienceTargets = new OEVersionTargetsAlphaBetaProds(
    {
        [OEScienceTargetType.anatomy]: [
            OETarget.humanEyeRetina,
            OETarget.humanEarMicro,
            OETarget.humanBrainPotential,
            OETarget.humanLiverSinusoid
        ]
    },
    {
        [OEScienceTargetType.anatomy]: OETarget.humanEyeRetina,
    },
    {
        [OEScienceTargetType.anatomy]: OETarget.humanEyeRetina,
    }
);

export const OEScienceFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyTargetSelection: !isLicensing,
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.anatomyTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEScienceTargets);

export const OEScienceStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEScienceTargets,
    OEScienceStartSelectionContent
);